import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function (section) {
	const items = [...section.querySelectorAll('.list li')];
	const articles = [...section.querySelectorAll('.details article')];
	const list = section.querySelector('.list ol');
	const phone = window.matchMedia('(max-width: 768px)');

	// Phones: an accordion (services-list.css), the first service open to begin with (services-list.blade.php). Elsewhere its state shows nothing.
	const setOpen = (article, open) => {
		article.classList.toggle('open', open);
		article.querySelector('.toggle').setAttribute('aria-expanded', open);
	};

	// Opens one and closes the others at once: animated, the ones above would shift it as they shrink. It unfolds animated.
	const openOnly = (article) => {
		articles.forEach((other) => {
			other.classList.toggle('instant', other !== article);
			setOpen(other, other === article);
		});
		// Their closed state applied before their transitions come back.
		void section.offsetHeight;
		articles.forEach((other) => other.classList.remove('instant'));
	};

	articles.forEach((article) => {
		const toggle = article.querySelector('.toggle');

		toggle.addEventListener('click', () => {
			if (article.classList.contains('open')) {
				setOpen(article, false);
				return;
			}

			// The page scrolls by what the others took, so the tapped row stays under the finger.
			const top = toggle.getBoundingClientRect().top;

			openOnly(article);
			window.scrollBy({ top: toggle.getBoundingClientRect().top - top, behavior: 'instant' });
		});
	});

	// On phones, a link to a service (the footer's) opens it before the page scrolls there.
	for (const link of document.querySelectorAll('a[href^="#service-"]')) {
		link.addEventListener('click', (event) => {
			if (!phone.matches) {
				return;
			}

			const article = section.querySelector(link.hash);

			event.preventDefault();
			openOnly(article);
			article.scrollIntoView({ behavior: 'smooth' });
			history.replaceState(null, '', link.hash);
		});
	}

	// The same media query as the sticky stage in services-list.css (the CSS one also requires JS).
	gsap.matchMedia().add('(min-width: 1200px)', () => {
		let current = -1;

		const show = (index) => {
			if (index === current) {
				return;
			}

			if (current >= 0) {
				gsap.to(articles[current], { opacity: 0, y: -30, duration: 0.3, ease: 'power2.in', overwrite: true });
			}

			gsap.fromTo(articles[index], { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: 0.5, delay: current >= 0 ? 0.2 : 0, ease: 'power2.out', overwrite: true });
			gsap.to(list, { '--marker-y': `${items[index].offsetTop}px`, duration: 0.5, ease: 'power3.out' });
			items.forEach((item, i) => item.classList.toggle('active', i === index));
			current = index;
		};

		const trigger = ScrollTrigger.create({
			trigger: section,
			start: 'top top',
			end: 'bottom bottom',
			onUpdate: ({ progress }) => show(Math.min(Math.floor(progress * articles.length), articles.length - 1)),
		});

		show(Math.min(Math.floor(trigger.progress * articles.length), articles.length - 1));

		// The articles share one spot, so the links to them (the list's and the footer's) scroll to the middle of their service's stretch instead.
		const links = [...document.querySelectorAll('a[href^="#service-"]')];
		const onClick = (event) => {
			event.preventDefault();
			const index = articles.findIndex((article) => `#${article.id}` === event.currentTarget.hash);
			window.scrollTo({ top: trigger.start + (trigger.end - trigger.start) * (index + 0.5) / articles.length });
		};

		links.forEach((link) => link.addEventListener('click', onClick));

		return () => {
			links.forEach((link) => link.removeEventListener('click', onClick));
			items.forEach((item) => item.classList.remove('active'));
		};
	});
}
